// update along with app/lib/enums/unmapped_attribute_status.py
const UnmappedAttributeStatus = {
  PENDING: 'PENDING',
  MAPPED: 'MAPPED',
};

export default UnmappedAttributeStatus;
